const InsuranceShieldIcon = ({ size = 18, color = "#D97706" }) => (
  <svg
    width={size}
    height={size}
    style={{ color }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3L4 6.5V12C4 16.1 7.4 19.9 12 21C16.6 19.9 20 16.1 20 12V6.5L12 3Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InsuranceShieldIcon;
